import { useEffect, useReducer } from "react";

import useTrafficSearchApiParams from "../../../hooks/useApiParamsSearch";
import {
    useTrafficData,
    useOrganicKeywordsData,
    usePaidKeywordsData,
    useBrandedSplitData,
    useRankDistributionData,
} from "../../../services/search-overview-api/apiHooks";
import { ESourceType } from "../../../types";

import { initialSearchMetricData, searchCarouselReducer } from "./searchCarouselReducer";
import {
    transformBrandedSplitData,
    transformKeywordsData,
    transformRankData,
    transformTrafficData,
} from "./transformers";

export const useSearchCarouselData = () => {
    const { trafficSearchApiParams } = useTrafficSearchApiParams();

    const {
        data: trafficData,
        isLoading: isTrafficDataLoading,
        isError: isTrafficDataError,
    } = useTrafficData(trafficSearchApiParams);

    const { data: organicKeywordsData, isLoading: isOrganicKeywordsLoading } = useOrganicKeywordsData({
        ...trafficSearchApiParams,
        SourceType: ESourceType.ORGANIC,
    });

    const { data: paidKeywordsData, isLoading: isPaidKeywordsLoading } = usePaidKeywordsData({
        ...trafficSearchApiParams,
        SourceType: ESourceType.PAID,
    });

    const {
        data: brandedSplitData,
        isLoading: isBrandedSplitLoading,
        isError: isBrandedSplitError,
    } = useBrandedSplitData(trafficSearchApiParams);

    const {
        data: rankData,
        isLoading: isRankDataLoading,
        isError: isRankDataError,
    } = useRankDistributionData(trafficSearchApiParams);

    const [searchMetricData, dispatch] = useReducer(searchCarouselReducer, initialSearchMetricData);

    useEffect(() => {
        transformTrafficData(trafficData, dispatch);
    }, [trafficData]);

    useEffect(() => {
        transformKeywordsData(organicKeywordsData, ESourceType.ORGANIC, dispatch);
    }, [organicKeywordsData]);

    useEffect(() => {
        transformKeywordsData(paidKeywordsData, ESourceType.PAID, dispatch);
    }, [paidKeywordsData]);

    useEffect(() => {
        transformBrandedSplitData(brandedSplitData, dispatch);
    }, [brandedSplitData]);

    useEffect(() => {
        transformRankData(rankData, dispatch);
    }, [rankData]);

    const isLoading = {
        organic: isTrafficDataLoading,
        paid: isTrafficDataLoading,
        all: isTrafficDataLoading,
        ppcSpend: isTrafficDataLoading,
        rankPosition: isRankDataLoading,
        branded: isBrandedSplitLoading,
    };
    const isError = {
        organic: isTrafficDataError,
        paid: isTrafficDataError,
        all: isTrafficDataError,
        ppcSpend: isTrafficDataError,
        rankPosition: isRankDataError,
        branded: isBrandedSplitError,
    };

    return {
        searchMetricData,
        isLoading,
        isError,
        isKeywordsLoading: {
            organic: isOrganicKeywordsLoading,
            paid: isPaidKeywordsLoading,
        },
    };
};
